/* ============================================================
   Dathent — onboardingSkip.js (TASK-278, issue #430)
   Account-scoped persistence for the explicit onboarding escape hatch.
   ============================================================ */

export const ONBOARDING_SKIP_KEY_PREFIX = 'dathent.onboarding.skipped.';

export function onboardingSkipKey(userId) {
  if (userId == null || String(userId).length === 0) return null;
  return `${ONBOARDING_SKIP_KEY_PREFIX}${String(userId)}`;
}

function resolveStorage(storage) {
  if (storage !== undefined) return storage;
  try {
    return globalThis.localStorage;
  } catch {
    return null;
  }
}

export function markOnboardingSkipped(userId, storage) {
  const key = onboardingSkipKey(userId);
  if (!key) return false;
  try {
    const target = resolveStorage(storage);
    if (!target) return false;
    target.setItem(key, '1');
    return true;
  } catch {
    return false;
  }
}

export function onboardingWasSkipped(userId, storage) {
  const key = onboardingSkipKey(userId);
  if (!key) return false;
  try {
    const target = resolveStorage(storage);
    return target ? target.getItem(key) != null : false;
  } catch {
    return false;
  }
}

export function clearOnboardingSkipped(userId, storage) {
  const key = onboardingSkipKey(userId);
  if (!key) return false;
  try {
    const target = resolveStorage(storage);
    if (!target) return false;
    target.removeItem(key);
    return true;
  } catch {
    return false;
  }
}
